__turbopack_context__.v({
  "modalHeader": "SummaryTiles-module__WkFOha__modalHeader",
});
